<div class="ncm" [class.draft]="!parametrizado">
  <div class="header">
    <div class="title">
      <span class="tags">
        <span class="status" [class.on]="parametrizado">
          {{ parametrizado ? "Parametrizado" : "Pendente" }}
        </span>
      </span>
      <h3>
        <span class="code">{{ ncm?.ncm | formatter: "ncm" }}</span>
        <span class="descricao" *ngIf="descricao">{{ descricao }}</span>
      </h3>
    </div>
    <div class="actions">
      <button type="button" class="btn edit" (click)="edit.emit()">
        <span class="pi pi-pencil"></span>
        <span class="label">Editar</span>
      </button>
      <button type="button" class="btn remove" (click)="remove.emit()">
        <span class="pi pi-trash"></span>
        <span class="label">Remover</span>
      </button>
    </div>
  </div>

  <p class="draft-badge" *ngIf="!parametrizado">
    <i class="pi pi-exclamation-triangle"></i>
    <span>
      Parametrizar: falta {{ faltantesTexto }}. A emissão de NF-e fica bloqueada
      até completar.
    </span>
  </p>

  <dl class="data">
    <div>
      <dt>Origem ICMS</dt>
      <dd [class.missing]="!ncm?.tributos?.icms?.origem">
        {{ ncm?.tributos?.icms?.origem || "—" }}
      </dd>
    </div>
    <div>
      <dt>CST/CSOSN ICMS</dt>
      <dd [class.missing]="!ncm?.tributos?.icms?.cst">
        {{ ncm?.tributos?.icms?.cst || "—" }}
      </dd>
    </div>
    <div>
      <dt>CST PIS</dt>
      <dd [class.missing]="!ncm?.tributos?.pis?.cst">
        {{ ncm?.tributos?.pis?.cst || "—" }}
      </dd>
    </div>
    <div>
      <dt>CST COFINS</dt>
      <dd [class.missing]="!ncm?.tributos?.cofins?.cst">
        {{ ncm?.tributos?.cofins?.cst || "—" }}
      </dd>
    </div>
    <div>
      <dt>CEST</dt>
      <dd>{{ (ncm?.cest | formatter: "cest") || "—" }}</dd>
    </div>
    <div>
      <dt>IBS/CBS</dt>
      <dd>{{ ibscbsTexto }}</dd>
    </div>
  </dl>

  <p class="dates">
    Editado em {{ ncm?.updatedAt | date: "dd/MM/yyyy HH:mm" }} · Criado em
    {{ ncm?.createdAt | date: "dd/MM/yyyy HH:mm" }}
  </p>
</div>
